import React from "react";
import { Dropdown } from "react-bootstrap";
import { NavLink } from 'react-router-dom';

const CpntHeaderBODropDownOptions: React.FC = () => {

  return (
    <>
        <Dropdown.Item as={NavLink} to="/admin/accueil">
            <i className="bi-house pe-2" />Accueil
        </Dropdown.Item> 
        {/* <Dropdown.Item as={NavLink} to="/admin/moncompte">
            <i className="bi-person-circle pe-2" />Mon Compte
        </Dropdown.Item> */}
        {/* <Dropdown.Item as={NavLink} to="/mesutilisateurs">
            <i className="bi-people pe-2" />Mes Utilisateurs
        </Dropdown.Item>
        <Dropdown.Item as={NavLink} to="/monorganisation">
            <i className="bi-buildings pe-2" />Mon Organisation
        </Dropdown.Item>
        <Dropdown.Item as={NavLink} to="/messervices">
            <i className="bi-boxes pe-2" />Mes Services
        </Dropdown.Item> */}
    </>
  );
};

export default CpntHeaderBODropDownOptions;
